import { PARTNER_CHARGING_SUMMARY } from 'actions/dataReport';

const initialState = {
  isLoading: false,
  partnerChargingSummary: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const partnerChargingSummaryReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case PARTNER_CHARGING_SUMMARY.REQUEST: {
      return { ...state, isLoading: true };
    }
    case PARTNER_CHARGING_SUMMARY.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        partnerChargingSummary: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case PARTNER_CHARGING_SUMMARY.FAIL: {
      return { ...state, isLoading: false };
    }
    default:
      return { ...state };
  }
};
export default partnerChargingSummaryReducer;
